import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { useState } from 'react'

import {
  ButtonGroup,
  DataInfo,
  DataItemContainer,
  DataItemRow,
  OpacityLabel,
  OpacitySliderContainer,
  OpacitySliderRange,
  OpacitySliderRoot,
  OpacitySliderThumb,
  OpacitySliderTrack,
  OpacityValue,
  SmallButton,
} from './ndeDataSection.styles'

interface Props {
  type: string
  data: number[][]
  primitiveId: string
  onDisplay: (type: string) => void
  onDelete: (type: string) => void
  sendKVCommand?: (json: object | string) => void
}

export const NDEDataItem: React.FC<Props> = ({
  type,
  data,
  primitiveId,
  onDisplay,
  onDelete,
  sendKVCommand,
}) => {
  const [opacity, setOpacity] = useState(0.5)

  const handleOpacityChange = (value: number[]) => {
    const newOpacity = value[0]
    setOpacity(newOpacity)
    if (sendKVCommand) {
      sendKVCommand({
        command: KestrelCommands.SET_NDE_OPACITY,
        primitiveId,
        ndeDataType: type,
        opacity: newOpacity,
      })
    }
  }

  return (
    <DataItemContainer>
      <DataItemRow>
        <DataInfo>
          <span style={{ fontWeight: 500, textTransform: 'capitalize' }}>
            {type}
          </span>
          <span style={{ color: 'rgba(255,255,255,0.6)' }}>
            {data.length} × {data[0]?.length || 0}
          </span>
        </DataInfo>
        <ButtonGroup>
          <SmallButton $variant='primary' onClick={() => onDisplay(type)}>
            Display
          </SmallButton>
          <SmallButton $variant='danger' onClick={() => onDelete(type)}>
            Delete
          </SmallButton>
        </ButtonGroup>
      </DataItemRow>
      <OpacitySliderContainer>
        <OpacityLabel>Opacity:</OpacityLabel>
        <OpacitySliderRoot
          value={[opacity]}
          onValueChange={handleOpacityChange}
          min={0}
          max={1}
          step={0.01}>
          <OpacitySliderTrack>
            <OpacitySliderRange />
          </OpacitySliderTrack>
          <OpacitySliderThumb />
        </OpacitySliderRoot>
        <OpacityValue>{Math.round(opacity * 100)}%</OpacityValue>
      </OpacitySliderContainer>
    </DataItemContainer>
  )
}
